import { call, put, takeLatest } from "@redux-saga/core/effects";
import { message } from "antd";
import FileSaver from "file-saver";
import { request } from "../../../apiConfig/api";
import { authHeader } from "../../../utils/utils";
import { UrlConstants } from "../../../utils/ApiConstants";
import {
  downloadAllocationFileFailure,
  downloadAllocationFileSuccess,
  downloadAllocationUploadTemplateFailure,
  downloadAllocationUploadTemplateSuccess,
  getAllocationHistoryFailure,
  getAllocationHistorySuccess,
  uploadProposalFailure,
  uploadProposalSuccess
} from "./action";
import {
  DOWNLOAD_ALLOCATION_FILE_REQUEST,
  DOWNLOAD_ALLOCATION_UPLOAD_TEMPLATE,
  GET_ALLOCATION_HISTORY_REQUEST,
  UPLOAD_PROPOSAL_REQUEST
} from "./actionTypes";


export function* getAllocationHistoryData(payload: any): Generator {
  const { page, size } = payload?.payload;
  try {
    const result: any = yield call(request, {
      url: `${UrlConstants.BASE_URL}loanallocation/history?page=${page}&size=${size}`,
      method: "GET",
      headers: {
        "content-type": "application/json",
        authorization: `${authHeader().Authorization}`,
      },
    });
    yield put(getAllocationHistorySuccess(result));
  } catch (error) {
    yield put(getAllocationHistoryFailure(error));
  }
}

export function* downloadAllocationUploadTemplate(): Generator {
  try {
    const result: any = yield call(request, {
      url: `${UrlConstants.BASE_URL}loanallocation/bulk/template`,
      method: "GET",
      responseType: "arraybuffer",
      headers: {
        "content-type": "application/octet-stream",
        authorization: `${authHeader().Authorization}`,
      },
    });
    if (result) {
      const blob: Blob = new Blob([result], {
        type: "application/vnd.ms-excel",
      });
      FileSaver.saveAs(blob, "loanallocation_upload_template.xlsx");
    }
    yield put(
      downloadAllocationUploadTemplateSuccess({ loading: false, data: true })
    );
    message.success({ duration: 3, content: "File downloaded Successfully." });
  } catch (error) {
    yield put(downloadAllocationUploadTemplateFailure(error));
    message.error({
      duration: 3,
      content: "Something went wrong! Please try again.",
    });
  }
}

export function* donwloadAllocationFile(payload: any): Generator {
  const { uniqueCode } = payload.payload;
  try {
    const result: any = yield call(request, {
      url: `${UrlConstants.BASE_URL}loanallocation/history/${uniqueCode}/download`,
      method: "GET",
      headers: {
        "Content-Type": "Content-Disposition",
        authorization: `${authHeader().Authorization}`,
      },
    });

    yield put(
      downloadAllocationFileSuccess({
        loading: false,
        done: true,
        data: result,
      })
    );
    message.success({ duration: 3, content: "File downloaded Successfully." });
  } catch (error) {
    yield put(
      downloadAllocationFileFailure({
        loading: false,
        done: false,
        data: error,
      })
    );
    message.success({
      duration: 3,
      content: "Something went wrong! Please try again.",
    });
  }
}

export function* uploadProposal(payload: any): Generator {
  const selectedFile = payload?.payload?.selectedFile;
  const formData = new FormData();

  formData.append("file", selectedFile);
  try {
    const result: any = yield call(request, {
      url: `${UrlConstants.BASE_URL}loanallocation/upload`,
      method: "POST",
      headers: {
        // "content-type": "application/json",
        authorization: `${authHeader().Authorization}`,
      },
      data: formData,
    });
    yield put(
      uploadProposalSuccess({ loading: false, done: true, data: result })
    );
    message.success({ duration: 3, content: "File uploaded Successfully." });
  } catch (error) {
    yield put(
      uploadProposalFailure({ loading: false, done: true, data: error })
    );
    message.success({
      duration: 3,
      content: "Something went wrong! Please try again.",
    });
  }
}

function* proposalSaga() {
  yield takeLatest(GET_ALLOCATION_HISTORY_REQUEST, getAllocationHistoryData);
  yield takeLatest(DOWNLOAD_ALLOCATION_FILE_REQUEST, donwloadAllocationFile);
  yield takeLatest(UPLOAD_PROPOSAL_REQUEST, uploadProposal);
  yield takeLatest(
    DOWNLOAD_ALLOCATION_UPLOAD_TEMPLATE,
    downloadAllocationUploadTemplate
  );
}

export default proposalSaga;
